import { combineReducers } from '@reduxjs/toolkit';

import appReducer from '../slices/appSlice';
import statsApi from '../slices/statsApi';

const rootReducer = combineReducers({
  app: appReducer,
  [statsApi.reducerPath]: statsApi.reducer,
});

export default rootReducer;
